<template>
  <el-select
    v-model="model"
    placeholder="请选择一个答案"
    @change="$emit('change', $event)"
  >
    <el-option
      v-for="{ label, value } in options"
      :key="value"
      :label="label"
      :value="value"
    ></el-option>
  </el-select>
</template>

<script>
export default {
  name: 'TableInput',

  props: {
    value: {
      type: null,
      required: true
    },
    options: {
      type: Array,
      required: true
    }
  },

  watch: {
    value: {
      handler (value) {
        this.model = value
      },
      immediate: true
    }
  },

  data () {
    return {
      model: ''
    }
  }
}
</script>
